(function(angular){
	'use strict';

	angular.module('hhv.filters',[])
		.filter('orderObjectBy', ['$filter', function($filter) {
			return function (items, fields, reverse) {
				var filtered = [];
				angular.forEach(items, function(item) {
					filtered.push(item);
				});
				return $filter('orderBy')(filtered, fields, reverse);
			};
		}])
		.filter('queryTidy', function() {
			var regOrOperator = /(:|\s|\|\||\||\,)/g;
			var regTagPrefix = /(#|tag:)/g;
			var regNamePrefix = /(\$|@|org:)/g;
			//var regOther = /(?:^|\s)([^#@$\s]+)/g;
			return function(text, reverse, toArray) {
				if(!text)
					return text;
				if(reverse){
					text = text.replace(regTagPrefix, 'tag:');
					text = text.replace(regNamePrefix, 'org:');
					text = text.replace(regOrOperator, ':');
				}else{
					text = text.replace(regTagPrefix, '#');
					text = text.replace(regNamePrefix, '$');
					text = text.replace(regOrOperator, ' ');
				}
				//text = text.replace(regName, '@');
				return text;
			};
		});
})(angular);